import React from 'react'
import { useEvent } from 'react-use-event-hook'

function useOnMount(effectFn) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(effectFn, [])
}

export function useOnUnmount(effectFn) {
  const eventEffect = useEvent(effectFn)
  React.useEffect(() => {
    return eventEffect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useOnMount
